import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor() {}

  makeDeepCopy(obj): Object {
    return JSON.parse(JSON.stringify(obj));
  }

  flattenObject(obj): string[] {
    const needs = this.makeDeepCopy(obj);

    const flattenedNeeds = Object.keys(needs).reduce(
      (acc, categorie) => acc.concat(needs[categorie]),
      []
    );
    return flattenedNeeds;
  }

  shuffle(arr) {
    const shuffledNeeds = arr.slice();

    for (let i = 0; i < shuffledNeeds.length - 1; i++) {
      const j = i + Math.floor(Math.random() * (shuffledNeeds.length - i));
      [shuffledNeeds[i], shuffledNeeds[j]] = [
        shuffledNeeds[j],
        shuffledNeeds[i],
      ];
    }

    return shuffledNeeds;
  }

  shuffleRepetitions(arr: any[], repetitions: number = 1): any[] {
    // use this line to not shuffle the first iteration of shown needs and from repetition 2 onwards the shuffle takes place
    // let shuffledArray = arr.slice();
    let shuffledArray = this.shuffle(arr);

    const appendRepetition = (arrToAppendTo: string[]) => {
      const arrToAppend = [];

      // only allow elements that are not the last element of the previous shuffle
      const lastElement = arrToAppendTo[arrToAppendTo.length - 1];
      const elementsToChoose = arr.filter((need) => need !== lastElement);

      // choose new first element and delete it from viable options
      const indexFirstElement = Math.floor(
        Math.random() * elementsToChoose.length
      );
      arrToAppend.push(elementsToChoose[indexFirstElement]);
      elementsToChoose.splice(indexFirstElement, 1);

      // add the last element again since it will no longer be the first element of the array which needs to be appended
      const finalShuffledArr = arrToAppend.concat(
        this.shuffle([lastElement].concat(elementsToChoose))
      );

      return arrToAppendTo.concat(finalShuffledArr);
    };

    // repetition is total repetitions of needs. The first shuffled needs array is the input
    for (let i = 0; i < repetitions - 1; i++) {
      shuffledArray = appendRepetition(shuffledArray);
    }

    return shuffledArray;
  }

  isConsecutiveDuplicate(arr: any[], index: number) {
    return arr[index].value == arr[index + 1].value

  }

  shuffleStimuli(arr: any[]) {
    //create a working copy of the input array
    let copyArray = arr.slice();

    let condition: boolean = true;
    let index: number = 0;
    let run: number = 1;
    let duplicateFound: boolean = false;

    while (condition) {
      // check if there is a consecutive duplicate
      if (this.isConsecutiveDuplicate(copyArray, index)) {
        // extract the duplicate
        let tmp = copyArray.splice(index, 1);
        // determine a random place to insert the duplicate
        let randomIndex = Math.floor(Math.random() * copyArray.length);
        // insert the former duplicate into the random place in the array
        copyArray.splice(randomIndex, 0, tmp[0]);

        duplicateFound = true;
      }
      index++;

      // check if the end of the array has been reached
      if (index + 1 == copyArray.length) {
        run++;
        if (duplicateFound == false) {
          condition = false;
        } else {
          // if a duplicate has been found in a previous run, do another run
          index = 0;
          duplicateFound = false;
        } // if
      } // if
    } // while

    // itterate over the working copy array as long as there are consecutive duplicates
    

    return copyArray;
  }

  getMediaType(fileName: string) {
    const fileType = fileName.split('.').pop();

    switch (fileType.toLowerCase()) {
      case 'pdf':
        return 'pdf';

      case 'jpeg':
      case 'jpg':
      case 'png':
      case 'svg':
        return 'images';

      default:
        return null;
    }
  }

  capitalizeWord(word: string) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  enumHasValue(inputEnum: Object, value: any): boolean {
    return Object.values(inputEnum).includes(value);
  }

  getCurrentTime() {
    return new Date().getTime();
  }

  isEmptyObject(obj: Object) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  getRandomIndexForArray(arr: any[]) {
    const totalAmount = arr.length;

    return Math.floor(Math.random() * totalAmount);
  }

  filterConfigs(studies: any[]) {
    const IATconfigs = studies.filter(
      (config) => config['type'] === 'IAT' || config['type'] === 'priming' || config['type'] === 'conjoint'
      );
    return IATconfigs
  }
}
